import { Button } from '@flos/react-ui';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../hooks/UseMediaQuery';
import { IRouterPage } from '../interfaces/interfaces';
import track from 'c9-tracking';

interface IProps {
    currentPage: IRouterPage;
    handleContinue: Function;
    loading: boolean;
    canContinue: boolean;
    previousPage: IRouterPage;
}

const NEVER_SHOW_BACK = [
    'error',
    'receipt',
    'finalize',
    'package-loader',
    'package',
    'rmo-receipt',
    'other-needs-coverage'
];

const PageNavigation = ({
    currentPage,
    handleContinue,
    loading,
    canContinue,
    previousPage
}: IProps): React.JSX.Element => {
    const isTablet = useMediaQuery('(max-width: 992px)');
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1);
        if (currentPage.key === 'shoppingcart') {
            track.interact([{ key: 'customer-navigated-back-from', value: currentPage.path }]);
        }
    };
    return (
        <>
            {currentPage.hasNavigation && (
                <div className="page-navigation">
                    <nav>
                        <div className="nav-button-wrapper">
                            <Button
                                minWidth={isTablet ? 'widest' : 'wide'}
                                onClick={() => handleContinue()}
                                disabled={loading || !canContinue}
                                data-testid="btContinue"
                                className="btContinue"
                            >
                                {currentPage.primaryBtnText ?? 'Fortsæt'}
                            </Button>
                            <Button
                                minWidth={isTablet ? 'widest' : 'wide'}
                                theme="ghost"
                                data-testid="btBack"
                                onClick={() => {
                                    handleGoBack();
                                }}
                            >
                                Tilbage
                            </Button>
                        </div>
                    </nav>
                </div>
            )}
            {!currentPage.hasNavigation && !NEVER_SHOW_BACK.includes(currentPage.key) && (
                <div className="btn-zero-margin">
                    <Button
                        minWidth={isTablet ? 'widest' : 'wide'}
                        theme="ghost"
                        className="btn--width-auto"
                        onClick={() => handleGoBack()}
                        data-testid="back-button"
                    >
                        Tilbage
                    </Button>
                </div>
            )}
        </>
    );
};

export { PageNavigation };
